import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {SaleState} from "@/interfaces/state/sale";
import store from "@/store";
import {Sale} from "@/interfaces/entity/sale";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {SaleParams} from "@/modules/sale/params";
import {createSale, deleteSale, listSale, singleSale, updateSale} from "@/modules/sale/services";

@Module({dynamic: true, name: "sales", store})
class SaleModule extends VuexModule implements SaleState {
    data: IdMapper<Sale> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: SaleParams = new SaleParams();

    @Mutation
    private MAP_SALES(payload: any) {
        const idMapper = {} as any;
        this.meta = payload.meta;
        this.ids = payload.datas.map((sale: Sale, index: number) => {
            idMapper[sale.id] = {...sale, stt: index + 1}
            return sale.id
        });
        this.data = idMapper;
    }

    @Mutation
    private UPDATE_PARAMS_SALE(payload: any) {
        this.params = payload;
    }

    @Mutation
    private DELETE_SALE(payload: Sale) {
        if (!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.ids = this.ids.filter((id: number) => id !== payload.id);
        delete this.data[payload.id];
    }

    @Action({ rawError: true })
    public async createSale(payload: any) {
        await createSale(payload);
    }

    @Action({ rawError: true })
    public async singleSale(payload: any) {
        const { data } = await singleSale(payload);
        return data.data;
    }

    @Action({ rawError: true })
    public async updateSale(payload: any) {
        await updateSale(payload.id, payload);
    }

    @Action({ rawError: true })
    public async deleteSale(payload: any) {
        const {data} = await deleteSale(payload);
        this.DELETE_SALE(data.data);
    }

    @Action({ rawError: true })
    public async listSale(params: any) {
        const { data } = await listSale(params);
        this.MAP_SALES(data);
    }

    @Action({ rawError: true })
    public updateParams(payload: any) {
        this.UPDATE_PARAMS_SALE(payload);
    }
}
export const SaleStore = getModule(SaleModule)
